<template>
  <div>
    <div class="tags">
      <el-form-item :label="labelText(zdItem.label)">
        <!-- 遍历 tags 显示标签 -->
        <el-tag
          :key="index"
          v-for="(tag, index) in zdFormattedValue"
          closable
          :disabled="setupDisable() || getAuthShow()"
          :disable-transitions="false"
          style="margin-right: 10px; margin-top: 10px;float: left;"
          @close="removeTag(index)"
        >
          <!-- 可点击的标签文本 -->
          <span 
            @click="editTag(tag, index)" 
            :style="{ cursor: canEdit() ? 'pointer' : 'default' }"
            :class="{ 'editable-tag': canEdit() }"
          >{{
            tag
          }}</span>
          <!-- 添加新标签的按钮 -->
          <el-button
            type="primary"
            :disabled="setupDisable() || getAuthShow()"
            style="padding: 0 2px; margin-left: 5px"
            size="small"
            @click="
              showTagInput('isInputVisible', 'tagInputRef', index, 'tagIndex')
            "
            >+</el-button
          >
          <!-- 向左移动标签的按钮 -->
          <el-button
            v-show="index > 0"
            type="primary"
            :disabled="zdItem.disabled || getAuthShow() || !canEdit()"
            style="padding: 0"
            size="small"
            icon="el-icon-arrow-left"
            @click="moveTagLeft(index)"
          ></el-button>
          <!-- 向右移动标签的按钮 -->
          <el-button
            v-show="index < zdFormattedValue.length - 1"
            type="primary"
            :disabled="zdItem.disabled || getAuthShow() || !canEdit()"
            style="padding: 0"
            size="small"
            icon="el-icon-arrow-right"
            @click="moveTagRight(index)"
          ></el-button>
        </el-tag>
        <!-- 添加新标签的输入框 -->
        <el-input
          class="input-new-tag"
          v-if="isInputVisible"
          :disabled="zdItem.disabled || getAuthShow()"
          v-model="inputValue"
          ref="tagInputRef"
          size="small"
          @keyup.enter.native="
            confirmInput()
          "
          @blur="confirmInput()"
        ></el-input>
        <!-- 显示输入框的按钮 -->
        <el-button
          :disabled="zdItem.disabled || getAuthShow()"
          style="float: left;margin-top: 10px;"
          v-else
          :class="tagStyle"
          size="small"
          @click="showInput('isInputVisible', 'tagInputRef')"
          >+ {{$t('action.add')}} {{labelText(zdItem.label)}}</el-button
        >
      </el-form-item>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import base from "@/common/base.js";
export default {
  name: "ZDTag",
  props: {
    zdId: {
      type: String,
      required: true,
    },
    pageStatus: {
      type: String,
      default: "Add",
    },
  },
  inject:['setupProductDescription'],
  computed: {
    // 从 Vuex 获取当前组件的整个状态
    ...mapGetters("zdInput", {
      zdGetComponentState: "getComponentState",
    }),
    // 获取当前组件的状态对象
    zdComponentState() {
      return this.zdGetComponentState(this.zdId);
    },
    // 从状态对象中获取各个字段
    zdItem() {
      return this.zdComponentState;
    },
    labelText() {
      return (label) => {
        let key = "content." + label;
        key = key.toLowerCase().replaceAll(" ", "_");
        return this.$t(key);
      };
    },
    zdFormattedValue: {
      get() {
        return this.zdItem.value || []; // 获取输入框的值，确保返回数组
      },
      set(value) {
        this.zdUpdateComponent({
          id: this.zdId,
          field: "value",
          value: value,
        }); // 更新输入框的值
      },
    },
    tagStyle() {
      if (this.zdFormattedValue.length > 0) {
        return "button-new-tag";
      }
      return "";
    },
  },
  data() {
    return {
      isInputVisible: false, // 控制输入框可见性的布尔值
      inputValue: "", // 输入框的值
    };
  },
  created() {
    // 监听页面状态变化
    this.$EventBus.$on("pageStatusChange", this.handlePageStatusChange);
    this.$EventBus.$on("tabChanged", this.handleTabChanged);
    // console.log("tag this.zdId:", this.zdId);
    this.commonOtherNameHandle();
  },
  
  beforeDestroy() {
    // 清理事件监听器
    this.$EventBus.$off("pageStatusChange", this.handlePageStatusChange);
    this.$EventBus.$off("tabChanged", this.handleTabChanged);
  },

  methods: {
    // 映射 Vuex 的动作
    ...mapActions("zdInput", ["updateComponent"]),
    zdUpdateComponent(payload) {
      this.updateComponent(payload); // 更新组件状态
    },
    getAuthShow(){
      return base.getAuthShow();
    },
    // 检查是否可以编辑
    canEdit() {
      const pageStatus = this.pageStatus;
      // console.info('pageStatus:',pageStatus)
      return pageStatus === 'Edit' || pageStatus === 'Add';
    },
    handleChange() {
      // console.info("this.zdItem:",this.zdItem)
      this.zdUpdateComponent({
        id: this.zdId,
        field: "value",
        value: this.zdItem.value,
      });
    },
    sendTagDataHandle() {
      this.commonOtherNameHandle();
    },
    // 显示输入框并聚焦
    showInput(isInputVisible, ref) {
      this[isInputVisible] = true;
      this.$nextTick(() => {
        this.$refs[ref].$refs.input.focus();
      });
    },
    // 在特定索引显示输入框并聚焦
    showTagInput(isInputVisible, ref, index, tagIndex) {
      this[tagIndex] = index + 1;
      this[isInputVisible] = true;
      this.$nextTick(() => {
        this.$refs[ref].$refs.input.focus();
      });
    },
    // 处理输入确认并将其添加到标签列表中
    confirmInput() {
      let inputValue = this.inputValue.trim(); // 去除首尾空格
      console.info('inputValue:',inputValue)
      if (inputValue) {
        
        // 将输入值添加到指定索引或末尾
        const newValue = [...this.zdFormattedValue, inputValue];
        console.info('newValue:',newValue)
        // 更新 zdFormattedValue
        this.zdFormattedValue = newValue;

        // this.sendTagDataHandle();
      }
      this.isInputVisible = false;
      this.inputValue = "";
    },
    // 处理点击标签以编辑其值
    editTag(tagContent, index) {
      if (!this.canEdit()) {
        return; // 如果不是编辑模式，直接返回
      }
      
      this.$prompt("修改值-->" + tagContent, "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValue: tagContent, // 预填充当前值
        inputValidator: (value) => {
          if (!value || !value.trim()) {
            return '标签内容不能为空';
          }
          // Part Used、Percentage 允许重复值，不进行查重
          const skipDupCheck = this.zdItem.label === 'Part Used' || this.zdItem.label === 'Percentage';
          if (!skipDupCheck) {
            const otherTags = this.zdFormattedValue.filter((_, i) => i !== index);
            if (otherTags.includes(value.trim())) {
              return '标签已存在，请使用不同的名称';
            }
          }
          return true;
        }
      })
        .then(({ value }) => {
          const trimmedValue = value.trim();
          const newValue = [...this.zdFormattedValue];
          newValue.splice(index, 1, trimmedValue);
          this.zdFormattedValue = newValue;
          this.$message.success('标签修改成功');
        })
        .catch(() => {
          // 用户取消编辑
        });
    },
    // 向左移动标签
    moveTagLeft(index) {
      if (index <= 0 || !this.canEdit()) {
        return; // 边界检查和权限检查
      }
      
      const newValue = [...this.zdFormattedValue];
      let tempTag = newValue[index - 1];
      newValue[index - 1] = newValue[index];
      newValue[index] = tempTag;
      this.zdFormattedValue = newValue;
      this.$message.success('标签向左移动成功');
    },
    // 向右移动标签
    moveTagRight(index) {
      if (index >= this.zdFormattedValue.length - 1 || !this.canEdit()) {
        return; // 边界检查和权限检查
      }
      
      const newValue = [...this.zdFormattedValue];
      let tempTag = newValue[index + 1];
      newValue[index + 1] = newValue[index];
      newValue[index] = tempTag;
      this.zdFormattedValue = newValue;
      this.$message.success('标签向右移动成功');
    },
    // 删除标签
    removeTag(index) {
      if (!this.canEdit()) {
        return; // 权限检查
      }
      
      this.$confirm('确定要删除这个标签吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const newValue = [...this.zdFormattedValue];
        newValue.splice(index, 1);
        this.zdFormattedValue = newValue;
        this.$message.success('标签删除成功');
      }).catch(() => {
        // 用户取消删除
      });
    },
    setupDisable(){
      const pageStatus = this.pageStatus;
      
      // 如果页面状态是Detail，所有字段都不可编辑
      if (pageStatus === "Detail") {
        return true;
      }
      
      // 如果页面状态是Edit，根据业务规则决定是否可编辑
      let type = this.$route.query.type;
      if(type =='coa' && pageStatus=='Edit'){
        let tmpArr =['product_name','customer_product_name','product_type',"ingredients","country_of_origin"];
        let key = this.zdItem.label.toLowerCase().replaceAll(" ", "_");
        if(tmpArr.includes(key)){
          return true;
        }
      }

      // 返回字段本身的disabled配置
      return this.zdItem.disabled || false;
    },
    commonOtherNameHandle(){
      //  TY-EHXTO、TY-SHXTO 类别
      if(this.zdItem.label=='Common Other Name'||this.zdItem.label=='Botanical Name'){
        // 此产品是精制${common_other_name_str}经超临界二氧化碳提取而得。
        let commonOtherNameStr = this.zdItem.value.join('_');
        this.setupProductDescription(commonOtherNameStr);
      }
    },
    handlePageStatusChange() {
      // 当页面状态变化时，重新计算是否可编辑
      this.$forceUpdate();
    },
    handleTabChanged() {
      // 当标签页变化时，重新计算是否可编辑
      this.$forceUpdate();
    }

  }
}
  
</script>

<style>
.tags {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
}
.button-new-tag {
  margin-left: 10px;
}
.editable-tag {
  color: #409EFF;
}
.editable-tag:hover {
  color: #66b1ff;
  text-decoration: underline;
}
</style>